module.exports = __webpack_public_path__ + "static/media/hero_bg.13677d0f.png";